import classNames from 'classnames'

type Props = {
  children: React.ReactNode
  className?: string
}

const HugeTitle = ({ children, className = '' }: Props) => {
  const clsName = classNames(
    'text-3xl leading-relaxed font-medium xl:text-6xl xl:leading-snug',
    className,
  )
  return <h1 className={clsName}>{children}</h1>
}

export default HugeTitle
